/**
 * MOQ (Minimum Order Quantity) helpers -- front-end mirror of web-API/Helpers/moqHelper.js.
 *
 * MOQ comes from Odoo (`x_studio_minimum_order_qty_pcs`) and is an arbitrary
 * non-negative integer, NOT a fixed set of levels. `0` means "no restriction".
 * MOQ is a FLOOR, not a step: with MOQ 10 a quantity of 13 stays 13.
 *
 * The server re-applies this in cartService.js and is authoritative; this copy
 * exists so the UI corrects the quantity immediately rather than after a round trip.
 */

/** Coerce an MOQ value to a usable integer. Odoo sends `false` when it was never set. */
export const normalizeMoq = (value: any): number => {
  const moq = parseInt(value, 10);
  return Number.isFinite(moq) && moq > 0 ? moq : 0;
};

/** Raise a quantity to the product's MOQ when it falls short; otherwise leave it alone. */
export const applyMoq = (quantity: any, moq: any): number => {
  const qty = parseInt(quantity, 10);
  // Non-positive quantities are passed through so "decrement to zero removes the
  // line" keeps working for products without an MOQ.
  if (!Number.isFinite(qty) || qty <= 0) return qty;
  const min = normalizeMoq(moq);
  return min > 0 && qty < min ? min : qty;
};
